import { InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Flex, Popover, Typography } from "antd";
import { DataType } from "../../model";

interface IDocstoreTableAction {
  deleteDocument: () => void;
  deleteStamps: () => void;
  data?: DataType;
}

export function DocstoreTableAction({
  deleteDocument,
  deleteStamps,
  data,
}: IDocstoreTableAction) {
  return (
    <Flex gap="small" justify="end">
      <Popover
        content={
          <Flex vertical gap="small">
            <Typography.Text>
              Автор: {data?.author?.name}
            </Typography.Text>
            <Typography.Text>Дата выдачи: {data?.date}</Typography.Text>
          </Flex>
        }
        trigger="click"
        arrow={false}
      >
        <InfoCircleOutlined style={{ width: "16px", height: "16px" }} />
      </Popover>
      <Popover
        content={
          <Flex vertical gap="small">
            <Button type="text" className="action-button">
              Редактировать
            </Button>
            <Button type="text" color="primary" className="action-button">
              <Typography.Text type="secondary" onClick={deleteDocument}>
                Удалить документ
              </Typography.Text>
            </Button>
            <Button type="text" color="primary" className="action-button">
              <Typography.Text type="secondary" onClick={deleteStamps}>
                Удалить все штампы
              </Typography.Text>
            </Button>
          </Flex>
        }
        trigger="click"
        arrow={false}
        placement="left"
      >
        <MoreOutlined />
      </Popover>
    </Flex>
  );
}
